// ------ nav paths
export const NAV_REGISTRATION_BASE = '/register';


// --> flow 1 for buyer/seller - public access
export const NAV_REGISTRATION_ENTRY = `${NAV_REGISTRATION_BASE}`;

export const NAV_REGISTRATION_FORM = `${NAV_REGISTRATION_BASE}/form`;

export const NAV_REGISTRATION_SUBMIT_SUCCESS = `${NAV_REGISTRATION_BASE}/success/:interest`;

export const NAV_REGISTRATION_VERIFY_EMAIL = `${NAV_REGISTRATION_BASE}/verify/email/:emailVerificationToken`;


// --> flow 2 for buyer/seller email verification - public access
// LEGACY FLOW for already sent mails
export const NAV_REGISTRATION_LEGACY_APPROVAL_STATUS = `${NAV_REGISTRATION_BASE}/contact/approval/:status/:interest`;

export const NAV_REGISTRATION_APPROVAL_STATUS = `${NAV_REGISTRATION_BASE}/approval/:status/:interest`;


// --> flow payment data - authenticated only from here
export const NAV_REGISTRATION_CUSTOMER_BASE = `${NAV_REGISTRATION_BASE}/customer`;

export const NAV_REGISTRATION_CUSTOMER_BILLING = `${NAV_REGISTRATION_CUSTOMER_BASE}/billing`;

export const NAV_REGISTRATION_CUSTOMER_DISTRIBUTION = `${NAV_REGISTRATION_CUSTOMER_BASE}/distribution`;

export const NAV_REGISTRATION_CUSTOMER_SUBMIT = `${NAV_REGISTRATION_CUSTOMER_BASE}/submit`;

export const NAV_REGISTRATION_CUSTOMER_SUBMIT_SUCCESS = `${NAV_REGISTRATION_CUSTOMER_BASE}/submit/success/:interest`;

export const NAV_REGISTRATION_CUSTOMER_APPOINTMENT = `${NAV_REGISTRATION_CUSTOMER_BASE}/appointment`;
